export default "__VITE_ASSET__DXUEoBVw__"